import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoginForm, DemoCredentials } from "../../components/auth";
import { useAuth } from "../../contexts/AuthContext";
import ForgotPassword from "./ForgotPassword";

const Login: React.FC = () => {
  const { isLoggedIn, isLoading, error, login } = useAuth();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
  };

  // Redirect to home if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/home");
    }
  }, [isLoggedIn, navigate]);

  if (showForgotPassword) {
    return <ForgotPassword onBackToLogin={handleBackToLogin} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Đăng nhập</h1>
          <p className="text-gray-600 text-sm">
            Vui lòng nhập thông tin đăng nhập
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-3 mb-4">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        {/* Login Form */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <LoginForm
            onSubmit={login}
            isLoading={isLoading}
            onForgotPassword={() => setShowForgotPassword(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
